import store, { actions } from "../../redux";
import { ConnectionsProps } from "../../redux/slices/connections/connections";
import { API_INSTANCES } from "../api_instance";
import { handleError } from "../errors";

const dispatch = store.dispatch;

const getConnections = () => {
  dispatch(actions.connections.setGetConnections_API_STATUS("progress"));
  API_INSTANCES.CONNECTIONS.getConnections()
    .then((response) => {
      const data = response.data as ConnectionsProps.Connections;
      dispatch(actions.connections.setConnections(data));
      dispatch(actions.connections.setGetConnections_API_STATUS("success"));
    })
    .catch((error) => {
      dispatch(actions.connections.setGetConnections_API_STATUS("error"));
      handleError(error, "getConnections");
    });
};
const followAUser = ({ id }: ConnectionsProps.FollowAUserPayload) => {
  dispatch(actions.connections.setSelectedUserId(id));
  dispatch(actions.connections.setFollowAUser_API_STATUS("progress"));
  API_INSTANCES.CONNECTIONS.followAUser({ id })
    .then(() => {
      dispatch(actions.connections.setFollowAUser_API_STATUS("success"));
      dispatch(
        actions.info.updateFollowingForEntityInfoResponse({
          id,
          is_following: true,
        })
      );
      dispatch(actions.connections.addFollowingUser(id));
    })
    .catch((error) => {
      dispatch(actions.connections.setFollowAUser_API_STATUS("error"));
      handleError(error, "followAUser");
    })
    .finally(() => {
      dispatch(actions.connections.setSelectedUserId(""));
    });
};
const unfollowAUser = (props: ConnectionsProps.UnFollowAUserPayload) => {
  const { id, onSuccess } = props;
  dispatch(actions.connections.setUnfollowAUser_API_STATUS("progress"));
  API_INSTANCES.CONNECTIONS.unfollowAUser({ id })
    .then(() => {
      dispatch(actions.connections.setUnfollowAUser_API_STATUS("success"));
      dispatch(
        actions.info.updateFollowingForEntityInfoResponse({
          id,
          is_following: false,
        })
      );
      dispatch(actions.connections.removeFollowingUserUsingId(id));
      onSuccess?.();
    })
    .catch((error) => {
      dispatch(actions.connections.setUnfollowAUser_API_STATUS("error"));
      handleError(error, "unfollowAUser");
    });
};
const getFollowCounts = () => {
  dispatch(actions.connections.setGetFollowCounts_API_STATUS("progress"));
  API_INSTANCES.CONNECTIONS.getFollowCounts()
    .then((response) => {
      const data = response.data as ConnectionsProps.FollowCounts;
      dispatch(actions.connections.setFollowCounts(data));
      dispatch(actions.connections.setGetFollowCounts_API_STATUS("success"));
    })
    .catch((error) => {
      dispatch(actions.connections.setGetFollowCounts_API_STATUS("error"));
      handleError(error, "getFollowCounts");
    });
};
const getFollowersUsers = (page: number) => {
  dispatch(actions.connections.setGetFollowersUsers_API_STATUS("progress"));
  API_INSTANCES.CONNECTIONS.getFollowersUsers(page)
    .then((response) => {
      const data =
        response.data as ConnectionsProps.FollowersUsers_API_RESPONSE;
      dispatch(actions.connections.setFollowersUsers(data));
      dispatch(actions.connections.setGetFollowersUsers_API_STATUS("success"));
    })
    .catch((error) => {
      dispatch(actions.connections.setGetFollowersUsers_API_STATUS("error"));
      handleError(error, "getFollowersUsers");
    });
};
const getFollowingUsers = (page: number) => {
  dispatch(actions.connections.setGetFollowingUsers_API_STATUS("progress"));
  API_INSTANCES.CONNECTIONS.getFollowingUsers(page)
    .then((response) => {
      const data =
        response.data as ConnectionsProps.FollowingUsers_API_RESPONSE;
      dispatch(actions.connections.setFollowingUsers(data));
      dispatch(actions.connections.setGetFollowingUsers_API_STATUS("success"));
    })
    .catch((error) => {
      dispatch(actions.connections.setGetFollowingUsers_API_STATUS("error"));
      handleError(error, "getFollowingUsers");
    });
};
const removeAFollower = (payload: ConnectionsProps.RemoveAFollowerPayload) => {
  dispatch(actions.connections.setRemoveAFollower_API_STATUS("progress"));
  const { id, onSuccess } = payload;
  API_INSTANCES.CONNECTIONS.removeAFollower({ id })
    .then(() => {
      dispatch(actions.connections.setRemoveAFollower_API_STATUS("success"));
      dispatch(actions.connections.removeFollowerUserUsingId(id));
      onSuccess?.();
    })
    .catch((error) => {
      dispatch(actions.connections.setRemoveAFollower_API_STATUS("error"));
      handleError(error, "removeAFollower");
    });
};
const searchUsers = (payload: ConnectionsProps.SearchUsersPayload) => {
  dispatch(actions.connections.setSearchUsers_API_STATUS("progress"));
  API_INSTANCES.CONNECTIONS.searchUsers(payload)
    .then((response) => {
      const data = response.data as ConnectionsProps.SearchUsers_API_RESPONSE;
      dispatch(
        actions.connections.setSearchUsersResponse({
          ...data,
          type: payload.type,
        })
      );
      dispatch(actions.connections.setSearchUsers_API_STATUS("success"));
    })
    .catch((error) => {
      dispatch(actions.connections.setSearchUsers_API_STATUS("error"));
      handleError(error, "searchUsers");
    });
};

export const CONNECTIONS = {
  getConnections,
  followAUser,
  unfollowAUser,
  getFollowCounts,
  getFollowersUsers,
  getFollowingUsers,
  removeAFollower,
  searchUsers,
};
